import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { HelperService } from '../../services/helper.service';
import { NotificationBuilder } from '../notificationBuilder';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { AdministratorService } from '../../administrator/administrator.service';
import { PlanService } from '../../services/plan.service';
import { PlanType } from '../../models/plantype.model';
import { Feature } from '../../models/feature';
import { PlanItem } from '../../models/planItem';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
declare var swal: any;
@Component({
    selector: 'plan-editor',
    templateUrl: './plan-editor.component.html',
})

export class PlanEditorComponent implements OnInit {
    @Input() seoUrl: string
    @Input() planItemId: string
    @Output() answer = new EventEmitter();
    isAdmin: boolean;
    loading: boolean
    planScaffoldList: Array<PlanType> = null
    featureList: Array<Feature> = null
    planItem: PlanItem = null
    typeValue: string = 'fixed'

    constructor(private helperService: HelperService, private authenticationService: AuthenticationService, public changeDetection: ChangeDetectorRef, private planService: PlanService, private adminService: AdministratorService, private notificationBuilder: NotificationBuilder, public ngxSmartModalService: NgxSmartModalService) {
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        console.log('ngAfterViewChecked');
        this.ngxSmartModalService.getModal('planEditorModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
            debugger
            // modal is the dismissed modal, so do what you want with it
            console.log('fechando planEditor');
            this.update(null)
        });
        this.ngxSmartModalService.getModal('planEditorModal').onCloseFinished.subscribe((modal: NgxSmartModalComponent) => {
            console.log('fechando planEditor no x');
            this.update(null)
        });
    }

    ngOnDestroy() {
        console.log('destroy');
    }

    ngOnChanges() {
        debugger
        if (this.seoUrl != null) {
            console.log('ticket: ' + this.seoUrl)
            this.openPlan()
        }
    }

    openPlan() {
        var obj = this

        if (this.seoUrl != null) {
            this.loadPlanEditor();
        }

        setTimeout(() => {
            obj.ngxSmartModalService.getModal('planEditorModal').open()
        }, 200);
    }

    loadPlanEditor() {
        if (this.seoUrl != null) {
            if (this.planItemId != null) {
                this.planService.adminGetPlanItem(this.planItemId, this.seoUrl).subscribe(data => {
                    debugger
                    console.log(data);
                    if (data.success) {
                        this.planItem = data.data;
                        this.loadPlans()
                        this.loadFeatures()
                    }
                })
            }
            else {
                this.planItem = new PlanItem();
                this.planItem.storeUrl = this.seoUrl;
                this.planItem.monetizationType = 0
                this.planItem.period = 1
                this.planItem.infinite = true
                this.planItem.active = true
                this.loadPlans()
                this.loadFeatures()
                this.populateDates()
            }
        }
    }

    loadPlans() {
        this.planService.adminGetAllActivePlans().subscribe(data => {
            debugger
            console.log(data);
            if (data != null) {
                this.planScaffoldList = data;
                if (this.planItem.planId == null) {
                    //seleciona por padrao customizado
                    this.planItem.planId = "423cacd1-e9ae-4567-ba38-374e2767d187"
                }
            }
        })
    }

    loadFeatures() {
        this.planService.adminGetAllFeatures().subscribe(data => {
            debugger
            console.log(data);
            if (data.success) {
                this.featureList = data.data;
            }
        })
    }

    ChangePlanScaffold(planId) {
        debugger
        planId = planId.split(':')[1].trim();
        var plan = this.planScaffoldList.find(x => x.id == planId)
        this.planItem.planId = plan.id
        this.planItem.planSeoName = plan.seoName
        this.planItem.planName = plan.name
    }

    populateDates() {
        debugger
        var currentdate = new Date();
        var startDate = this.planItem.startDate;
        if (this.planItem.startDate == null) {
            startDate = currentdate
        }
        else {
            startDate = new Date(this.planItem.startDate)
        }

        var endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + parseInt(this.planItem.period));

        this.planItem.startDate = (startDate.getMonth() + 1) + "/"
            + startDate.getDate() + "/"
            + startDate.getFullYear()
        this.planItem.endDate = (endDate.getMonth() + 1) + "/"
            + endDate.getDate() + "/"
            + endDate.getFullYear()
    }

    save() {
        var obj = this
        if (this.planItem != null) {
            debugger
            this.planService.adminSavePlanItem(this.planItem, this.seoUrl).subscribe(data => {
                debugger
                if (data.success) {
                    obj.notificationBuilder.showNotification('success', 1000, 'planItem ' + obj.planItem.name + ' criado com sucesso')
                    obj.ngxSmartModalService.getModal('planEditorModal').close()
                    //window.location.reload()
                } else {
                    this.notificationBuilder.showNotification('danger', 1000, 'ocorreu um erro: ' + data.data)
                }
            })
        }
    }

    update(model: any) {
        debugger
        var obj = this
        this.answer.emit({
            "planEditor": model
        });
    }

    trackFeatureById(index: number, item: Feature) {
        return index
    }

    AddRemoveFeature(type) {
        debugger
        if (type == "plus") {

            var feature = this.featureList.find(x => x.id == this.planItem.featureId);
            if (this.planItem.features == null)
                this.planItem.features = [];
            this.planItem.features.push(feature);
            this.planItem.name = feature.name
            this.planItem.description = feature.description
            this.planItem.priceType = feature.priceType
            this.planItem.price = feature.value
            this.planItem.mrr = feature.value

        }
        else {
            this.planItem.features.pop()
        }
    }


    editBankFeePlanItem() {
        if (this.planItem.bankFee == null)
            this.planItem.bankFee = {}
        this.ngxSmartModalService.getModal('planItemBankFeeModal').open()
    }

    savePlanItemBankFee() {
        var obj = this
        swal({
            icon: 'info',
            title: "Tem certeza, olhou direito?",
            text: "Colocar um percentual errado pode ser trágico! ",
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            cancelButtonText:
                'Eita, vou conferir',
            confirmButtonText:
                'Tenho certeza'
        }).then((result2) => {
            this.loading = true
            debugger
            this.planService.savePlanItemBankFee(this.planItem.id, this.planItem.bankFee).subscribe(data => {
                if (data.success) {
                    this.notificationBuilder.showNotification('success', 1000, 'Dados salvos com sucesso')
                } else {
                    this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados')
                }
            })
        }, function (dismiss2) {
            debugger
        });
    }
}

export class HubspotNewTicket {
    seoUrl: string;
    type: string;
    subject: string;
    content: string;
}
